export class Pagination {
    currentPage: number;
    totalPage: number;
    pageSize: number;
    itemPerPage: number;
    startIndex: number;
    endIndex: number;
    constructor(page: number = 1, totalPage: number = 0, pageSize: number = 10, itemPerPage:number = 15){
        this.currentPage = page;
        this.totalPage = totalPage;
        this.pageSize = pageSize;
        this.itemPerPage = itemPerPage;
        this.startIndex = 0;
        this.endIndex = 0;
    }
}


// WEBPACK FOOTER //
// ./src/holiday/models/Pagination.ts